import { domainEnvironment } from './domain/domain-environment';
import { IEnvironment, mergeEnvironment } from '../environment';

const env: IEnvironment = {
    production: false,
    pusher: {
        key: '64f5905058516b2ae3c1',
        keyEU: '52617bcc8845d5870535',
        cluster: 'mt1',
        clusterEU: 'eu',
        wsHost: 'undefined',
        wsPort: 'undefined',
        wssPort: 'undefined',
        config: {
            wsHost: 'undefined'
        }
    },
    euEnrollment: {
        baseUrl: 'https://enroll.dev.personifyhealth.eu'
    },
    naEnrollment: {
        baseUrl: 'https://enroll.dev.personifyhealth.com'
    },
    ecommerce: {
        baseUrl: 'https://shop.member.dev.personifyhealth.com'
    },
    genesis: {
        baseUrl: 'app.dev.personifyhealth.com',
        baseApiUrl: 'https://api.dev.personifyhealth.com',
        cookieDomain: 'dev.personifyhealth.com'
    },
    env: {
        env: 'dev'
    },
    newrelic: {
        licenseKey: '1592d695bb',
        applicationID: '1134349248',
        accountID: '1105211',
        agentID: '1134349248'
    },
    s3: {
        basePath: 'dv'
    },
    autoLogoutMinutes: 15,
    logoutWarningSeconds: 60,
    authenticationProvider: 'keycloak',
    authServer: {
        agentRealm: 'agents',
        baseUrl: 'https://login.dev.personifyhealth.com',
        realmUrl: 'https://login.dev.personifyhealth.com/auth/realms/platform',
        realm: 'platform',
        clientId: 'platform-ui'
    },
    mixpanel: {
        token: 'c4615868771ec94d2854bebd7bef0eeb'
    },
    filepicker: {
        apiKey: 'ADWCWgGyuQGqoL2vo8lftz',
        virusDetectWorkflowId: '34de2cba-e987-4f10-9dd1-2f04b0d38061',
        container: 'qa-ph-platform-content'
    },
    securedFilepicker: {
        apiKey: 'AlyUg44HJQmkTL4VkfCBQz',
        virusDetectWorkflowId: '2064be5a-2f88-44ec-bbfd-9fb8f3466e8a',
        container: 'qa-secured-filestack-application'
    },
    zendesk: {
        url: 'personifyhealth1683549045.zendesk.com',
        widgetSrc: 'https://static.zdassets.com/ekr/snippet.js?key=4ea18ae8-f50e-4919-a514-e4c6270cae02'
    },
    cognigy: {
        url: 'https://endpoint-app-us.cognigy.ai/6ab1dad8f969055e48598182886cbda611c46771061996ddbc68ac364380ef6b',
        phaPersonalSupportUrl: 'https://endpoint-app-us.cognigy.ai/975e620afe120d09e647af5adc62fd9fdb015b3d9b0efd98a5aca4b023f2012c',
        phaTechnicalSupportUrl: 'https://endpoint-app-us.cognigy.ai/6ab1dad8f969055e48598182886cbda611c46771061996ddbc68ac364380ef6b'
    },
    castle: {
        publishableKey: 'pk_puoHss3sRaxxLdWCz7UPJGRRFe3GwVoZ'
    },
    amCharts: {
        license: 'CH270993136'
    },
    wellsource: {
        adminCenterUrl: 'https://personifyhealth.staging.iv.wellsuite.com/WsWebAppWellSuite/admin.html'
    },
    tinyMCE: {
        apiKey: 'axdzp8me2c65ge19t3z8z4dv7owmr7q8osqct4ohea3dk5c7'
    },
    microfrontendCdn: {
        url: 'https://microfrontend-ui.qa-cdn.personifyhealth.com'
    },
    mixpanelClient: {
        token: '49fefb4f4eced6a269bd79f95fb4986a'
    },
    electron: {
        healthCenter: {
            repo: 'https://electrify.qa.personifyhealth.com/health-station/',
            channel: 'snapshot'
        }
    },
    healthComp: {
        base: 'https://hconline-dev.healthcomp.pri/api/'
    },
    braze: {
        us: {
            apiKey: '2cc6f0b2-8e3d-495c-983e-34043d9ff654',
            sdkEndpoint: 'sdk.iad-02.braze.com'
        },
        eu: {
            apiKey: '14e9dae5-98ce-4e2a-bd4e-25ab233c93ba',
            sdkEndpoint: 'sdk.fra-02.braze.eu'
        }
    },
    formBuilder: {
        base: 'https://survey.stage.personifyhealth.com/'
    }
};

export const environment = mergeEnvironment(env, domainEnvironment);
